import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { StarRating } from 'components/StarRating/StarRating';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';
import { stringSeparatedWords } from '../helpers';
import { ClassDetailsTime } from './ClassDetailsTime';
import { ClassDetailsVenueAddress } from './ClassDetailsVenueAddress';

export const messages = defineMessages({
  classUnavailable: {
    id: 'inviteafriend.class-unavailable',
    defaultMessage: 'Class is no longer available',
  },
});

/** Card displaying the details of the class the invitee is being invited to */
export const ClassDetailsCard = ({ schedule }) => {
  const { venue } = schedule;
  const classHeaderImage = venue.images.default;

  // e.g. "Barry's Bootcamp - NoMad"
  const venueNameAndAlias = stringSeparatedWords(' - ', venue.name, venue.location?.name);

  const classUnavailable = schedule.availability.status !== 'available';

  return (
    <div className="card ClassDetailsCard">
      <div className="ClassDetailsCard__header-image-container">
        <img src={classHeaderImage} role="presentation" alt="" />
        {classUnavailable && (
          <div className="ClassDetailsCard__header-image-unavailable-overlay">
            <LocalizableMessage message={messages.classUnavailable} />
          </div>
        )}
      </div>
      <div className="ClassDetailsCard__content-container">
        <div className="ClassDetailsCard__class-name">{schedule.class.name}</div>
        <div className="ClassDetailsCard__class-date">
          <ClassDetailsTime schedule={schedule} />
        </div>
        <div className="ClassDetailsCard__separator" />
        <div className="ClassDetailsCard__venue-name">{venueNameAndAlias}</div>
        <StarRating
          singleStar
          showRatingNumber
          rating={venue.ratings.mean}
          count={venue.ratings.display_total}
          className="ClassDetailsCard__venue-rating"
        />
        <div className="ClassDetailsCard__venue-address">
          <ClassDetailsVenueAddress venue={venue} />
        </div>
      </div>
    </div>
  );
};

ClassDetailsCard.propTypes = {
  schedule: PropTypes.object.isRequired,
};
